import React from 'react';
import moment from 'moment';
import { DeleteAppointmentHoliday } from './actionButtons/DeleteAppointmentHoliday';

function TableRow(props) {
  const { appointmentHoliday, index, actionCallback } = props;

  if ( ! appointmentHoliday) {
    return null;
  }

  return (
    <tr>
      <td>{ moment.unix(appointmentHoliday.day_as_timestamp).format("DD-MM-YYYY") }</td>
      <td>{ appointmentHoliday.description ?? "" }</td>
      <td className="w-10">
        <DeleteAppointmentHoliday
            appointmentHoliday={ appointmentHoliday }
            index={ index }
            actionCallback={ actionCallback }
        />
      </td>
    </tr>
  )
}

export { TableRow };
